import clockIcon from 'assets/icons/clockThree.svg'
import closeIcon from 'assets/icons/close.svg'
import { Modal } from 'components/Modal'
import { kickoffColumns, kickoffModalFootnote, kickoffModalIntro } from 'constants/ProjectSetUpConstants'

interface KickoffSessionModalProps {
  isOpen: boolean
  onClose: () => void
}

export const KickoffSessionModal = ({ isOpen, onClose }: KickoffSessionModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className="kickoff-modal">
      <div className="rapid-modal-sticky-header pt-6 px-6">
        <div className="flex items-start justify-between gap-4 w-full mb-1">
          <p className="headline-m">Kickoff session</p>
          <button onClick={onClose} aria-label="Close">
            <img src={closeIcon} alt="" width={16} height={16} />
          </button>
        </div>

        <p className="body-m mb-4 w-full">{kickoffModalIntro}</p>
      </div>
      <div className="px-6">
        <div className="kickoff-columns">
          {kickoffColumns.map(column => (
            <div key={column.key} className="kickoff-column" style={{ backgroundColor: column.bgColor }}>
              <div className="kickoff-column-header">
                <p className="title-xxs uppercase" style={{ color: column.headerColor }}>
                  {column.title}
                </p>
              </div>
              <div className="kickoff-column-body">
                <div className="kickoff-chip" style={{ backgroundColor: column.chipColor }}>
                  <img src={clockIcon} alt="" width={16} height={16} />
                  <span className="subtitle-s">{column.time}</span>
                  <span className="kickoff-chip-divider" />
                  <span className="subtitle-s">{column.ledBy}</span>
                </div>
                <ul className="kickoff-item-list">
                  {column.items.map(item => (
                    <li key={item.text}>
                      {item.bold && <span className="font-bold">{item.bold}</span>}
                      {item.text}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
      <p className="body-xs color-neutral-80 mt-4 w-full px-6 pb-6">{kickoffModalFootnote}</p>
    </Modal>
  )
}
